<template>
  <div class="title-card">
    <div class="wrap">
      <div v-if="isSwitch"
           class="titles-wrap">
        <span class="titles-item"
              :class="{ active: selectedLabel === item.id }"
              v-for="item in titles"
              :key="item.name"
              @click="switchHandle(item)">{{ item.name || item.label }}</span>
      </div>
      <div v-else
           class="title">{{ title }}</div>
      <div class="more"
           v-if="showMore"
           @click="moreClick">
        {{ moreText }}
        <a-icon type="double-right" />
      </div>
      <slot name="rightOperation"></slot>
    </div>
    <div class="spanning-wrap"
         v-if="loading">
      <a-spin class="spin-item"
              :spinning="loading" />
    </div>
    <span v-if="emptyOpt.isEmpty"
          v-empty="emptyOpt"></span>
    <!-- 卡片内容 -->
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    customEmptyOptions: Object, // 自定义判空的配置
    defaultSelected: Number, // 默认选中的tab
    isSwitch: {
      // 切换模式
      type: Boolean,
      default: () => false
    },
    moreText: {
      type: String,
      default: () => '更多'
    },
    title: {
      type: String,
      default: () => '我是标题'
    },
    titles: {
      type: Array,
      default: () => []
    },
    showMore: {
      type: Boolean,
      default: () => true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    isEmpty: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      moreClickStstus: false,
      selectedLabel: '',
      emptyOpt: {
        isEmpty: false,
        description: '无相关信息匹配'
      }
    }
  },
  mounted() {
    this.selectedLabel = this.defaultSelected // 赋值默认设置的tab
    if (this.customEmptyOptions) {
      Object.assign(this.emptyOpt, this.customEmptyOptions) // 如果有默认的判空配置就融合
    }
  },
  watch: {
    isEmpty(nVal) {
      this.emptyOpt.isEmpty = nVal
    },
    defaultSelected(val) {
      this.selectedLabel = val
    }
  },
  methods: {
    moreClick() {
      this.moreClickStstus = !this.moreClickStstus
      this.$emit('moreClick', this.moreClickStstus)
    },
    switchHandle(item) {
      this.selectedLabel = item.id
      this.$emit('switchTitle', item)
    }
  }
}
</script>
